import React from 'react'

function CostumerSupport() {
    return (
        <div>
            CostumerSupport
        </div>
    )
}

export default CostumerSupport
